import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Builds a full name from first, optional middle, and last name.
 */
export function getFullName(person: {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}): string {
  return [person.firstName, person.middleName, person.lastName].filter(Boolean).join(' ').trim();
}
